import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { SpedPaper } from './spedComponentTabs/spedNotesStyled';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import { FormInputCheckbox } from 'components/Common/Forms/FormInputCheckbox';

export const SpedNoteHeading = ({ handleClose }) => (
  <Grid container item alignItems="center">
    <Grid item xs={12} sm={8}>
      <Typography variant="h6">Create SPED Note</Typography>
    </Grid>

    <Grid item xs={12} sm={4} textAlign="end">
      <Button variant="text" onClick={handleClose}>
        Clear Filters
      </Button>
    </Grid>
  </Grid>
);

const agreementText = `I agree that by typing my name below, it will serve as my electronic signature and has the same legal effect as my handwritten signature.`;

export const SignaturePair = ({
  errors,
  control,
  readOnly,
  inputName,
  inputLabel,
  checkboxName,
  inputPlaceholder,
}) => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <MDBox mb={2} />
        <FormInputCheckbox
          errors={errors}
          control={control}
          name={checkboxName}
          readOnly={readOnly}
          label={agreementText}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MDBox mb={1} />
        <FormInputText
          type="text"
          shrink={true}
          name={inputName}
          control={control}
          label={inputLabel}
          readOnly={readOnly}
          placeholder={inputPlaceholder}
          errors={!!errors?.[inputName]}
          helperText={errors?.[inputName]?.message || ' '}
        />
      </Grid>
    </>
  );
};

export const SignatureHeading = ({ title }) => (
  <Stack sx={{ mb: 1 }}>
    <Typography variant="h6">{title}</Typography>
  </Stack>
);

export const SignatureBlock = ({
  title,
  errors,
  control,
  inputName,
  inputLabel,
  checkboxName,
  inputPlaceholder,
}) => {
  return (
    <SpedPaper>
      <SignatureHeading title={title} />

      <Grid container spacing={0} alignItems="center">
        <Grid item xs={12} md={6}>
          <FormInputCheckbox
            errors={errors}
            control={control}
            name={checkboxName}
            label={agreementText}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormInputText
            type="text"
            shrink={true}
            control={control}
            name={inputName}
            label={inputLabel}
            placeholder={inputPlaceholder}
            errors={!!errors?.[inputName]}
            helperText={errors?.[inputName]?.message || ' '}
          />
        </Grid>
      </Grid>
    </SpedPaper>
  );
};

export const formatServiceDateTime = (date, time) => {
  if (!date || !time) return null;

  const [hours, minutes] = time.split(':');
  const d = new Date(date);

  d.setHours(Number(hours));
  d.setMinutes(Number(minutes));
  d.setSeconds(0);
  d.setMilliseconds(new Date().getMilliseconds());

  const pad = (n, size = 2) => String(n).padStart(size, '0');

  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.` +
    `${pad(d.getMilliseconds(), 3)}000`
  );
};
